import React from 'react'

function Elimu2() {
  return (
    <div>
        
        <b>Family income benefit</b><br></br>
        This benefit provides monthly income to the family in event of untimely death of the policy holder until the policy matures.<br></br>
        <b>Child hospitalization benefit</b><br></br>
        The rider pays a fixed cash amount for each day during which the insured (child) is hospitalized following an accident.<br></br>
        <b>Disability benefit</b><br></br>
        If you are unable to continue with premium payments due to disability by reason of sickness or accident, Britam will waive all future premiums. All other benefits will be payable when due.<br></br>
        <b>Accidental indemnity benefit</b><br></br>
        This rider will pay an additional temporary disablement benefit, hospitalization benefit and a death benefit following an accident.<br></br>
        <b> Funeral expense cover</b><br></br>
        The rider provides a lump sum benefit on death of the insured to cover for funeral expenses and is payable within 48 hours.<br></br>





    </div>
  )
}

export default Elimu2